(function () {
  const STORE = (window.deliveryDiscountTimelineO2 = window.deliveryDiscountTimelineO2 || {});
  const MOTION = { duration: 220, easing: 'ease-out' };

  class DeliveryDiscountTimelineO2 extends HTMLElement {
    connectedCallback() {
      this.context = this.dataset.context || 'cart-page';
      this.progress = Number(this.dataset.progress || 0);
      this.remainingCents = Number(this.dataset.remainingCents || 0);

      const previous = STORE[this.context];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.animateFill(previous, reduceMotion);
      this.animateAmount(previous, reduceMotion);

      STORE[this.context] = {
        progress: this.progress,
        remainingCents: this.remainingCents,
      };
    }

    disconnectedCallback() {
      const context = this.context || this.dataset.context || 'cart-page';
      window.setTimeout(() => {
        if (!document.querySelector(`delivery-discount-timeline-o2[data-context="${context}"]`)) delete STORE[context];
      });
    }

    animateFill(previous, reduceMotion) {
      const fill = this.querySelector('[data-delivery-discount-fill]');
      if (!fill) return;

      const currentTransform = `scaleX(${this.progress / 100})`;
      fill.style.transform = currentTransform;

      if (!previous || reduceMotion || previous.progress === this.progress) return;

      fill.animate(
        [
          { transform: `scaleX(${previous.progress / 100})` },
          { transform: currentTransform },
        ],
        MOTION
      );
    }

    animateAmount(previous, reduceMotion) {
      const amount = this.querySelector('[data-delivery-discount-amount]');
      if (!amount || !previous || reduceMotion || previous.remainingCents === this.remainingCents) return;

      const from = previous.remainingCents;
      const to = this.remainingCents;
      const startedAt = performance.now();
      amount.textContent = this.formatCzk(from);

      const tick = (now) => {
        const progress = Math.min((now - startedAt) / MOTION.duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        amount.textContent = this.formatCzk(from + (to - from) * eased);

        if (progress < 1) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    }

    formatCzk(cents) {
      const crowns = Math.max(0, Math.round(cents / 100));
      const locale = document.documentElement.lang || 'cs-CZ';

      if (!this._czkFormatter || this._czkFormatterLocale !== locale) {
        this._czkFormatter = new Intl.NumberFormat(locale);
        this._czkFormatterLocale = locale;
      }

      return `${this._czkFormatter.format(crowns)}\u00a0Kč`;
    }
  }

  if (!customElements.get('delivery-discount-timeline-o2')) {
    customElements.define('delivery-discount-timeline-o2', DeliveryDiscountTimelineO2);
  }
})();
